<p *transloco="let t" class="error">
    {{ t('generic_error') }}
</p>